<template>
	<div v-if="!!item.section" class="dropdown-header headline-font">
		<span v-html="item.title"></span>
	</div>

	<div v-else-if="!!item.separator" class="dropdown-divider"></div>

	<span v-else-if="!!item.disabled" :class="classObject">
		<div v-if="!!item.icon" class="dropdown-icon disabled">
			<font-awesome-icon :icon="item.icon"></font-awesome-icon>
		</div>
		<div v-if="!!item.title" class="dropdown-title disabled">
			{{ item.title }}
		</div>
	</span>

	<a v-else-if="!!item.link && !item.action" :class="classObject" :href="item.link">
		<div v-if="!!item.icon" class="dropdown-icon">
			<font-awesome-icon :icon="item.icon"></font-awesome-icon>
		</div>
		<div v-if="!!item.title" class="dropdown-title">
			{{ item.title }}
		</div>
	</a>

	<button v-else :class="classObject" @click.prevent="action">
		<div v-if="!!item.icon" class="dropdown-icon">
			<font-awesome-icon :icon="item.icon"></font-awesome-icon>
		</div>
		<div v-if="!!item.title" class="dropdown-title">
			{{ item.title }}
		</div>
	</button>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			default: {},
			required: true,
		},
	},
	computed: {
		classObject: function() {
			return {
				'dropdown-item': true,
				destructive: !!this.item.destructive,
				disabled: !!this.item.disabled,
			}
		},
	},
	methods: {
		action: function() {
			this.$parent.closeDropdown()

			if (!this.item.action) return

			if (typeof this.item.action == 'function') return this.item.action.apply(this)
			else if (typeof this.$root[this.item.action] !== 'undefined')
				return this.$root[this.item.action].apply(this)
			else return false
		},
	},
}
</script>
